import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import ImageGenerator from '../components/ImageGenerator';

const Create = () => {
  const [recentImages, setRecentImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    fetchRecentImages();
  }, []);

  const fetchRecentImages = async () => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('userToken');
      const userId = localStorage.getItem('userId');

      const response = await axios.get(`${process.env.REACT_APP_API_URL}/recent-images/${userId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      setRecentImages(response.data.images?.slice(0, 6) || []);
    } catch (error) {
      console.error('Error fetching recent images:', error);
      setError('Failed to load recent images');
    } finally {
      setLoading(false);
    }
  };

  const onImageGenerated = (newImage) => {
    if (newImage) {
      console.log('New image data:', newImage); // Add this line
      const formattedImage = {
        image_url: newImage.imageUrl,
        prompt: newImage.usedParams.prompt,
        created_at: new Date().toISOString()
      };
      console.log('Formatted image:', formattedImage); // Add this line
      setRecentImages(prev => [formattedImage, ...prev.slice(0, 5)]);
      fetchRecentImages();
    }
  };

  const styles = {
    container: {
      padding: '20px',
      maxWidth: '1200px',
      margin: '0 auto'
    },
    recentImagesSection: {
      marginTop: '40px'
    },
    sectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    },
    title: {
      fontSize: '24px',
      color: '#333',
      margin: 0
    },
    viewMoreButton: {
      padding: '8px 16px',
      backgroundColor: '#4CAF50',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer',
      fontSize: '16px',
      transition: 'background-color 0.3s'
    },
    imagesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '20px',
      marginTop: '20px'
    },
    imageCard: {
      border: '1px solid #ddd',
      borderRadius: '8px',
      overflow: 'hidden',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
      backgroundColor: 'white'
    },
    image: {
      width: '100%',
      aspectRatio: '1',
      objectFit: 'cover'
    },
    imageInfo: {
      padding: '10px'
    },
    date: {
      color: '#666',
      fontSize: '0.9em',
      marginBottom: '5px'
    },
    prompt: {
      margin: '0',
      fontSize: '0.95em',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },
    noImages: {
      textAlign: 'center',
      color: '#666',
      padding: '20px'
    },
    error: {
      color: '#dc3545',
      textAlign: 'center',
      padding: '20px'
    },
    loading: {
      textAlign: 'center',
      padding: '20px',
      color: '#666'
    }
  };

  return (
    <div style={styles.container}>
      <ImageGenerator onImageGenerated={onImageGenerated} />
      
      <div style={styles.recentImagesSection}>
        <div style={styles.sectionHeader}>
          <h2 style={styles.title}>Recent Generations</h2>
          {recentImages.length > 0 && (
            <button 
              style={styles.viewMoreButton}
              onClick={() => navigate('/public-gallery')}
            >
              View More
            </button>
          )}
        </div>

        {loading && (
          <div style={styles.loading}>Loading recent images...</div>
        )}

        {error && (
          <div style={styles.error}>{error}</div>
        )}

        {!loading && !error && recentImages.length === 0 && (
          <div style={styles.noImages}>
            No images generated yet. Try creating your first image above!
          </div>
        )}

        {!loading && !error && recentImages.length > 0 && (
          <div style={styles.imagesGrid}>
            {recentImages.map((image, index) => (
              <div key={image.id || index} style={styles.imageCard}>
                <img 
                  src={image.image_url} 
                  alt={`Generated ${index + 1}`}
                  style={styles.image}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSIjZjVmNWY1Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGRvbWluYW50LWJhc2VsaW5lPSJtaWRkbGUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiBmb250LXNpemU9IjE2IiBmaWxsPSIjYWFhIj5JbWFnZTwvdGV4dD48L3N2Zz4=';
                  }}
                />
                <div style={styles.imageInfo}>
                  <p style={styles.date}>
                    {new Date(image.created_at).toLocaleDateString()}
                  </p>
                  <p style={styles.prompt}>
                    {image.prompt || 'Generated Image'}
                  </p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Create;